"use client"

import { MapPinCheck } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MapPinCheckIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MapPinCheckIcon = component(Icon)({ as: MapPinCheck })
